// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__10W_Q","content":"Consent_content__2GKSE","footer":"Consent_footer__hi8dO"};